import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-style-seven',
  templateUrl: './courses-style-seven.component.html',
  styleUrls: ['./courses-style-seven.component.scss']
})
export class CoursesStyleSevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
